import { ILocale, ILocalizable } from "infrastructure/localization";
import { INotification } from "infrastructure/notification";
import { IValidationIssue } from "infrastructure/validation";
import { IIndustry, IApiError } from "ui/shared/models/common";

export enum ValidationTags {
  Description,
  Translation,
  Both
}

export interface ITranslationsManagerFilter {
  supportedLocales?: ILocale[];
  locales: ILocale[];
  localeCanOpen?: boolean;
  industries: IIndustry[];
  industryCanOpen?: boolean;
  statuses: ILocalizable[];
  sources: ILocalizable[];
  lastData?: ITranslationsManagerFilterData;
}

export interface ITranslationsManagerGrid {
  gridData: ITermTranslationRow[];
  selected: ITermTranslationRow[];
  isSearched: boolean;
}

export interface ITranslationsManagerState {
  filter: ITranslationsManagerFilter;
  grid: ITranslationsManagerGrid;
  notifications: INotification[];
  isLoading: boolean;
  isExportDisabled: boolean;
}

export interface ITranslationsManagerFilterData {
  selectedLocale?: ILocale;
  selectedIndustry?: IIndustry;
  selectedStatus?: ILocalizable;
  selectedSource?: ILocalizable;
  filterText?: string;
  filterKey?: string;
}

export interface ITermTranslationRow {
  data: ITermTranslationRelationship;
  originalData?: ITermTranslationRelationship;
  isTranslationChanged: boolean;
  isTranslationDefinitionChanged: boolean;
  index: number;
  validationIssues: IValidationIssue[];
}

export interface ITermTranslationRelationship {
  translationId?: string;
  termId: string;
  term: string;
  definition: string;
  locale?: string;
  industry?: string;
  translation?: string;
  translationDefinition?: string;
  translationStatus?: string;
  translationSource?: string;
  translationVersion: number;
  flareId?: string;
  author?: string;
  authorName?: string;
  index: number;
}

export interface ITermTranslationModel {
  translationId: string;
  termId: string;
  locale?: string;
  industry?: string;
  translation?: string;
  definition?: string;
  version: number;
}

export interface ITermTranslationErrorModel {
  translationId: string;
  error: IApiError;
}

export interface IChangeText {
  index: number;
  text?: string;
}

export interface ITermTranslationModifyData {
  isTranslationChanged: boolean;
  isTranslationDefinitionChanged: boolean;
  index: number;
  translation?: string;
  translationDefinition?: string;
  originalData?: ITermTranslationRelationship;
  translationId?: string;
  validationIssues: IValidationIssue[];
}

export const getInitialTranslationsManagerState = (): ITranslationsManagerState => ({
  filter: { locales: [], industries: [], statuses: [], sources: [] },
  grid: { gridData: [], selected: [], isSearched: false },
  notifications: [],
  isLoading: false,
  isExportDisabled: true
});

export type SelectorState = { translationsManager: ITranslationsManagerState };

const getStateSelectorsProvider = () => ({
  getFilter: (state: SelectorState) => state.translationsManager.filter,
  getFilterLastData: (state: SelectorState) => state.translationsManager.filter.lastData,
  getGridRows: (state: SelectorState) => state.translationsManager.grid.gridData,
  getSelectedGridRows: (state: SelectorState) => state.translationsManager.grid.selected,
  getNotifications: (state: SelectorState) => state.translationsManager.notifications
});

export const selectors = getStateSelectorsProvider();
